__turbopack_context__.v({
  "author": "TestimonialCard-module-scss-module__Mivd-a__author",
  "authorContent": "TestimonialCard-module-scss-module__Mivd-a__authorContent",
  "container": "TestimonialCard-module-scss-module__Mivd-a__container",
  "nextButton": "TestimonialCard-module-scss-module__Mivd-a__nextButton",
  "prevButton": "TestimonialCard-module-scss-module__Mivd-a__prevButton",
  "quote": "TestimonialCard-module-scss-module__Mivd-a__quote",
  "role": "TestimonialCard-module-scss-module__Mivd-a__role",
});
